import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";

const blogPosts = [
  {
    id: "manager-massage-impact",
    date: "2025-06-10",
    title: {
      hu: "A munkahelyi masszázsterápia hatása a teljesítményre",
    },
    summary: {
      hu: "A professzionális munkahelyi masszázs hatékonyságnövelő és fizikai megterhelést csökkentő hatása.",
    },
  },
  {
    id: "medical-pedicure-benefits",
    date: "2025-06-15",
    title: {
      en: "Gyógypedikűr: Több, mint egyszerű lábápolás",
      hu: "Gyógypedikűr: Több, mint egyszerű lábápolás",
    },
    summary: {
      en: "A professzionális gyógypedikűr hogyan előzi meg a lábproblémákat és javítja az általános életminőséget.",
      hu: "A professzionális gyógypedikűr hogyan előzi meg a lábproblémákat és javítja az általános életminőséget.",
    },
  },
  {
    id: "reflexology-therapy",
    date: "2025-06-29",
    title: {
      hu: "Talpreflexológiai kezelés egyensúlyteremtés céljából",
    },
    summary: {
      hu: "Talpreflexológia: a belső egyensúly lábon keresztül",
    },
  },
  {
    id: "lymphatic-massage",
    date: "2025-06-27",
    title: {
      hu: "Manuális nyirokdrenázs szakszerű kivitelezése",
    },
    summary: {
      hu: "Nyirokmasszázs: a méregtelenítés természetes útja",
    },
  },
  {
    id: "medical-pedicure",
    date: "2025-07-30",
    title: {
      hu: "Gyógypedikűr – nem csak esztétika, hanem megelőzés is",
    },
    summary: {
      hu: "A gyógypedikűr különösen hasznos a következő esetekben:",
    },
  },
  {
    id: "massage-pedicure-foot",
    date: "2025-10-19",
    title: {
      hu: "Több, mint pedikűr: A masszázs gyógyereje a lábadnak",
    },
    summary: {
      hu: "Egy friss pedikűr csodákra képes: rendbe hozza a körmöket, puhává varázsolja a bőrt, és feltöltött érzést ad. De mi lenne ha...",
    },
  },
  {
    id: "thermal-baths-massage",
    date: "2025-07-30",
    title: {
      hu: "Gyógy‑ és wellness masszázs a budapesti termálfürdőkben",
    },
    summary: {
      hu: "Miért különlegesek Budapest termálfürdői?Milyen masszázsokat kínálnak a fürdőkben? ",
    },
  },
];

const Blog = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="container  mt-5 py-5">
      <Helmet>
        <Helmet>
          <title>Blog | Csillag Masszázs Pedikűr</title>
          <meta
            name="description"
            content="Olvassa el szakmai blogunkat masszázsról, reflexológiáról, gyógypedikűrről és egészségmegőrzésről."
          />
          <link rel="canonical" href="https://janoseszter.com/hu/Blog" />

          <meta property="og:title" content="Csillag Masszázs Pedikűr Blog" />
          <meta
            property="og:description"
            content="Friss szakmai cikkek a masszázs és pedikűr világából. Tudjon meg többet kezeléseinkről!"
          />
          <meta property="og:url" content="https://janoseszter.com/hu/Blog" />
          <meta
            property="og:image"
            content="https://janoseszter.com/images/logo225.png"
          />
          <meta property="og:site_name" content="janoseszter.com" />
          <meta property="og:type" content="website" />
        </Helmet>

        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1684163547956689"
          crossorigin="anonymous"
        ></script>
      </Helmet>

      <h1 className="mb-5 ">{t("Blog")}</h1>

      <div className="row ">
        {blogPosts.map((post) => (
          <div className="col-12 col-md-6 mb-4" key={post.id}>
            <div className="card h-100 shadow-sm">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{post.title[lang]}</h5>
                <small className="text-muted mb-2">
                  {new Date(post.date).toLocaleDateString(lang)}
                </small>
                <p className="card-text">{post.summary[lang]}</p>
                <NavLink
                  to={`/${lang}/Blog/${post.id}`}
                  className="mt-auto btn btn-outline-primary"
                >
                  Bővebben...
                </NavLink>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
